// extracted by mini-css-extract-plugin
export default {"banner":"PLIF73ouJsyOqp3bMfFy","megacrab-picture":"nm6GLe25HALi0XELXLUL","megacrab-bg":"UUCRiYzXOpxKFaYZzKER"};